import React, { createContext, useContext, useMemo } from 'react';
import { STRINGS } from './strings';

const LanguageContext = createContext('en');

function detectLanguage() {
  if (typeof navigator === 'undefined') return 'en';
  const candidates = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
  for (const code of candidates) {
    if (code && code.toLowerCase().startsWith('tr')) return 'tr';
  }
  return 'en';
}

export function LanguageProvider({ children }) {
  const lang = useMemo(detectLanguage, []);
  return <LanguageContext.Provider value={lang}>{children}</LanguageContext.Provider>;
}

// Picks the right side of a `{ en, tr }` field for the active language,
// falling back to English — used for any value, not just strings.js keys.
export function localize(field, lang) {
  if (field && typeof field === 'object' && !Array.isArray(field) && 'en' in field) {
    return field[lang] ?? field.en;
  }
  return field;
}

export function useLanguage() {
  const lang = useContext(LanguageContext);
  const t = (key) => localize(STRINGS[key], lang) ?? key;
  return { lang, t, L: (field) => localize(field, lang) };
}
